import { Redirect } from 'react-router-dom';

const HarmonyRedirect = () => <Redirect to="/tests/harmony" />;

export default HarmonyRedirect;
